import { createSlice } from '@reduxjs/toolkit'
import AppConfModel from "./AppConfModel";

const initialState: AppConfModel = {
    iC: '',
    iCl: '',
    name: '',
    slogan: "¡Refresca tu día en La Frappería!",
    colors: {
        navigationTheme: 'dark',
        mainBackground: '#000',
        mainTextLight: '#fff',
        mainTextDark: '#fff',
        titleBackground:'#000',
        tabIconDefault: '#ccc',
        tabIconSelected: '#fff',
        buttonPrimaryTextColor: '#fff',
        buttonPrimaryBackground: '#007bff',
        buttonSuccessTextColor: '#fff',
        buttonSuccessBackground: '#28a745',
        labelSuccess: '#28a745',
        inputBackground: '#cec5c544',
        inputBackground2: '#cec5c5',
        headerTintColor: 'white',
        priceColor: '#168916',
        addressBackground:'rgb(111, 108, 108)',
        productTitleBackground:'#dcdcdc99'
    }
}

export const counterSlice = createSlice({
    name: 'appConf',
    initialState,
    reducers: {
        reducerConfLoad: (state, action) => {
            state.iC = action.payload.ic
            state.iCl = action.payload.ic.toLowerCase()
            state.colors = action.payload.colors
        }
    },
})
export const { reducerConfLoad } = counterSlice.actions
export default counterSlice.reducer


/*

const colorsRC:any = {
	navigationTheme: 'dark',
	mainBackground: '#000',
	mainTextLight: '#fff',
	mainTextDark: '#fff',
	titleBackground:'#000',
	tabIconDefault: '#ccc',
	tabIconSelected: '#fff',
	buttonPrimaryTextColor: '#fff',
	buttonPrimaryBackground: '#007bff',
	buttonSuccessTextColor: '#fff',
	buttonSuccessBackground: '#28a745',
	labelSuccess: '#28a745',
	inputBackground: '#cec5c544',
	inputBackground2: '#cec5c5',
	headerTintColor: 'white',
	priceColor: '#168916',
	addressBackground:'rgb(111, 108, 108)',
	productTitleBackground:'#dcdcdc99'
};
const colorsLF:any = {
	navigationTheme: 'dark',
	mainBackground: '#923f1e',
	mainTextLight: '#fff',
	mainTextDark: '#fff',
	titleBackground:'#c56934',
	tabIconDefault: '#ccc',
	tabIconSelected: '#fff',
	buttonPrimaryTextColor: '#fff',
	buttonPrimaryBackground: '#007bff',
	buttonSuccessTextColor: '#fff',
	buttonSuccessBackground: '#28a745',
	labelSuccess: '#28a745',
	inputBackground: '#cec5c544',
	inputBackground2: '#cec5c5',
	headerTintColor: 'white',
	priceColor: '#168916',
	addressBackground:'rgb(146 63 30 / 65%)',
	productTitleBackground:'rgb(146 63 30 / 25%)'
};

*/